<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="600"
	>
		<v-card>
			<!-- Cabecera del formulario -->
			<v-card-title class="headline">
				<v-flex xs9>
					<v-icon>{{ form.id ? 'edit' : 'add' }}</v-icon> {{ form.id ? 'Editar Rol' : 'Crear Rol'}}
				</v-flex>
				<v-spacer></v-spacer>
				<v-btn icon @click.native="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>

			<!-- Cuerpo del formulario -->
			<v-form
				@submit.prevent="save"
				v-model="valid"
				ref="form"
				lazy-validation
				>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12>
								<v-text-field
									name="label"
									label="Descripción"
									v-model="form.descripcion"
									autofocus
									maxlength="50"
									:rules="$validate(['required'])"
									required
								></v-text-field>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<small class="error--text text-required">* Los campos son obligatorios</small>
					<v-spacer></v-spacer>
					<v-btn
						@click.native="close()">
						<v-icon>cancel</v-icon> {{$t('common.cancel') }}
					</v-btn>
					<v-btn
						color="primary"
						type="submit"
						:loading="loading"
						:disabled="!valid">
						<v-icon dark>check</v-icon> {{$t('common.save') }}
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import validate from '@/common/mixins/validate'; // Importación de mixin de validaciones

export default {
	// Definición de mixins importados
	mixins: [validate],
	// Variables iniciales
	data () {
		return {
			dialog: false,
			form: {},
			valid: false,
			loading: false
		}
	},
	mounted () {
		this.$bus.$on('openDialogCrearActualizarRol', item => {
			this.form = item
			this.dialog = true
		})
	},
	methods: {
		close () {
			this.form = {},
			this.loading = false
			this.valid = false
			this.$bus.$emit('closeDialog')
			this.dialog = false
		},
		async save () {
			if (this.$refs.form.validate()) {
				this.loading = true
				try {
					if (this.form.id) {
						const id = this.form.id
						delete this.form.id
						delete this.form._user_created
						delete this.form._user_updated
						delete this.form._created_at
						delete this.form._updated_at
						delete this.form.recursos
						await this.$service.graphql({
							query: `
								mutation edit($id: ID!, $rol: EditRol!){
									rolEdit(id: $id, rol: $rol){
										id
									}
								}
							`,
							variables: {
								id: id,
								rol: this.form
							}
						})
					} else {
						this.form.id_estado = 1
						await this.$service.graphql({
							query: `
								mutation add($rol: NewRol!){
									rolAdd(rol: $rol){
										id
									}
								}
							`,
							variables: {
								rol: this.form
							}
						})
					}
				} catch (error) {
					console.log(e)
				}
				this.$message.success()
				this.loading = false
				this.close()
			}
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/rol-recurso/dialogs/CrearActualizarRol.vue